// extracted by mini-css-extract-plugin
export default {"file":"EditorFile_file__jJGBL"};